import { Routes, Route, Navigate } from 'react-router-dom';
import EmployeeLayout from '../components/employee/EmployeeLayout.jsx';
import VisaApprovalQueuePage from './approver/VisaApprovalQueuePage.jsx';
import ReviewVisaPage from './approver/ReviewVisaPage.jsx';

export default function VisaApproverPage() {
  return (
    <Routes>
      <Route element={<EmployeeLayout />}>
        <Route index element={<VisaApprovalQueuePage />} />
        <Route path=":userId/:id" element={<ReviewVisaPage />} />
        <Route path="*" element={<Navigate to="/visa-approvals" replace />} />
      </Route>
    </Routes>
  );
}
